import React from "react";
// import ReactDom from "react-dom"
import "./App.css";
import Sidebar from "./Sidebar.js";
import Feed from "./Feed.js";
import Widgets from "./Widgets.js"

function App() {
  return (
    <div class="app">
      <Sidebar />
      <Feed />
      <Widgets />
    </div>
  );
}

export default App;
